import { SvgIcon, SvgIconProps } from '@mui/material'

const CopilotIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 64 74">
    <path
      d="M32 2 C 20 18, 8 36, 8 48 A 24 24 0 0 0 56 48 C 56 36, 44 18, 32 2 Z"
      fill="currentColor"
    />
    <circle cx="22" cy="48" r="3.6" fill="#66F0A0" />
    <circle cx="32" cy="48" r="3.6" fill="#66F0A0" />
    <circle cx="42" cy="48" r="3.6" fill="#66F0A0" />
  </SvgIcon>
)

export default CopilotIcon
